import Splide from '@splidejs/splide';

const ENABLED = window.outerWidth >= 768;

if (document.querySelector('#Carousel') && ENABLED) {
  new Splide('#Carousel', {
    pagination: false,
    perPage: 1,
    gap: 24,
    fixedWidth: 780,
    padding: { right: 50 }
  }).mount();
}

document.querySelectorAll('.js-reference').forEach(element => {
  new Splide(element, {}).mount();
});

// if (document.querySelector('#reference')) {
//   new Splide('#reference', {

//   }).mount();
// }

if (document.querySelector('#events-jumbo')) {
  new Splide('#events-jumbo', {
    arrows: false,
    type: 'loop',
    mediaQuery: 'min',
    breakpoints: {
      768: {
        arrows: true
      }
    }
  }).mount();
}

if (document.querySelector('#events-jumbo-empty')) {
  new Splide('#events-jumbo-empty', {
    arrows: false,
    drag: false,
    pagination: false
  }).mount();
}

if (document.querySelector('#events')) {
  new Splide('#events', {
    arrows: false,
    type: 'loop',
    mediaQuery: 'min',
    breakpoints: {
      768: {
        arrows: true
      },
      1240: {
        arrows: false,
        drag: false,
        pagination: false,
        perMove: 3,
        perPage: 3,
        type: 'slide'
      }
    }
  }).mount();
}

if (document.querySelector('#references_1')) {
  new Splide('#references_1', {
    arrows: false,
    autoplay: true,
    autoWidth: true,
    direction: 'rtl',
    drag: false,
    easing: 'linear',
    gap: 30,
    interval: 0,
    pagination: false,
    pauseOnHover: false,
    speed: 120000,
    type: 'loop',
    // mediaQuery: 'min',
    // breakpoints: {
    //   992: {
    //     perMove: 1,
    //     perPage: 3
    //   }
    // }
  }).mount();
}

if (document.querySelector('#references_2')) {
  new Splide('#references_2', {
    arrows: false,
    autoplay: true,
    autoWidth: true,
    drag: false,
    easing: 'linear',
    gap: 30,
    interval: 0,
    pagination: false,
    pauseOnHover: false,
    speed: 120000,
    type: 'loop',
    // mediaQuery: 'min',
    // breakpoints: {
    //   992: {
    //     perMove: 1,
    //     perPage: 3
    //   }
    // }
  }).mount();
}

if (document.querySelector('#PhotoCarousel')) {
  new Splide('#PhotoCarousel', {
    pagination: true,
    autoHeight: true
  }).mount();
}

if (document.querySelector('#js-MentorsCarousel')) {
  new Splide('#js-MentorsCarousel', {
    pagination: false,
    autoHeight: true,
    autoWidth: true,
    drag: false,
    gap: 15,
    omitEnd: true,
    focus: 0,
    mediaQuery: 'min',
    breakpoints: {
      768: {
        perPage: 2,
        gap: 20,
        padding: { right: 20 }
      },
      992: {
        gap: 40,
        perPage: 3
      },
    }
  }).mount();
}
